import ApiService from "../utils/ApiService";
import { getParsedNumber, roundNumber } from "../utils/Common";
import dayjs from "dayjs";

export class ReportService {
  #calculateFields = [
    "Net Total",
    "VAT",
    "SD",
    "Discount",
    "Gross Total",
    "Sold Price",
    "Amount",
    "Paid Amount",
    "Refund Amount",
  ];

  constructor() { }

  getCalculateField() {
    return this.#calculateFields;
  }

  getDateAndTime(isoString) {
    const dateObj = new Date(isoString);
    const day = dateObj.getDate().toString().padStart(2, "0");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    const formattedDate = `${day} ${month} ${year}`;

    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedTime = `${hours}:${minutes} ${ampm}`;

    return { formattedDate, formattedTime };
  }

  static formatDataList(data) {
    const formatedData = [];
    const instance = new ReportService();
    data.map((item, idx) => {
      if (item.hasOwnProperty("dateTime") || item.hasOwnProperty("createdAt") || item.hasOwnProperty("validFrom") || item.hasOwnProperty('validUntil')) {
        const { validUntil, validFrom, dateTime, payment, status, paymentReceiveTypes, createdAt, ...rest } = item;
        const itemKeys = Object.keys(item);

        itemKeys.forEach((key) => {
          if (key === "paymentReceiveTypes") {
            rest["payment"] = paymentReceiveTypes.map(pItem => pItem.paymentReceiveType === 'SSLC' ? {...pItem, paymentReceiveType: 'Online'}: pItem);
          } if (key === "dateTime") {
            const { formattedDate, formattedTime } = instance.getDateAndTime(item[key]);
            rest["date"] = formattedDate;
            rest["time"] = formattedTime;
            // rest["payment"] = payment;
          } if (key === "validFrom") {
            const { formattedDate, formattedTime } = instance.getDateAndTime(item[key]);
            rest["validFromDate"] = formattedDate;
            rest["validFromTime"] = formattedTime;
          } if (key === "validUntil") {
            const { formattedDate, formattedTime } = instance.getDateAndTime(item[key]);
            rest["validUntilDate"] = formattedDate;
            rest["validUntilTime"] = formattedTime;
          } if (key === "createdAt") {
            const { formattedDate, formattedTime } = instance.getDateAndTime(item[key]);
            rest["date"] = formattedDate;
            rest["time"] = formattedTime;
            rest["status"] = status;
          }
        });
        formatedData.push({ ...rest });
      }
    });
    return formatedData;
  }

  static getCalculationFields() {
    const instance = new ReportService();
    return instance.getCalculateField();
  }

  static getTableColumns(data) {
    if (data.length < 1) {
      return;
    }

    let cols = Object.keys(data[0]);
    for (let i = 0; i < cols.length; i++) {
      let tempColName = cols[i].replace(/([A-Z])/g, " $1").trim();
      cols[i] = tempColName.charAt(0).toUpperCase() + tempColName.slice(1);
      if (cols[i].length <= 3) {
        cols[i] = cols[i].toUpperCase();
      }
    }
    cols = ["SN", ...cols];

    return cols;
  }

  static getHeaderTextColor(colName) {
    const colors = ["#000000", "#341557"];
    const blackText = ["VAT", "SD", "Discount", "Mobile", "Order Type"];
    return blackText.includes(colName) ? `text-[${colors[0]}]` : `text-[${colors[1]}]`;
  }

  static placeCurrencyText(val) {
    if (typeof val === "string" && !isNaN(val.trim())) {
      if (val.split(".").length > 1) {
        return true;
      }
    }
    return false;
  }

  static #getFieldFromCol(name) {
    if (name.length <= 3) {
      return name.toLowerCase();
    } else {
      name = name.split(" ").join("");
      return name.charAt(0).toLowerCase() + name.slice(1);
    }
  }

  static getColumnTotal(reports, col) {
    let total = 0;
    const fieldName = this.#getFieldFromCol(col);

    reports.map((report) => {
      total += Number(report[fieldName]);
    });
    return total.toLocaleString("en", { minimumFractionDigits: 2 });
  }

  static calculateRefundAmout(reports) {
    let totalPaidAmount = 0;
    let totalRefundAmount = 0;
    let totalPendingAmount = 0;

    reports.map((report) => {
      totalPaidAmount += Number(report.paidAmount);
      if (report.status === "Pending") {
        totalPendingAmount += Number(report.refundAmount);
      }
    });

    totalRefundAmount = totalPaidAmount - totalPendingAmount;

    return { totalRefundAmount, totalPendingAmount };
  }

  static #keyToText(key) {
    if (key == "toDay") {
      return "Today";
    }
    return key
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase())
      .replace("To ", "To");
  }

  static #formatReportSummary(summary) {
    if (!summary || typeof summary !== "object") return [];

    return Object.entries(summary).map(([key, value]) => ({
      title: this.#keyToText(key),
      subTitle: "",
      amount: getParsedNumber(value),
    }));
  }

  static isTextValid(text) {
    if (text == "" || text == null) {
      return false;
    }
    if (!/^[^a-zA-Z0-9]/.test(text)) {
      return false;
    }
    return true;
  }

  static formatDateTime(isoString) {
    const date = new Date(isoString);

    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(",", "");
  }

  static #formatItemWiseSales(itemWiseList) {
    const data = [];
    itemWiseList.map((item, idx) => {
      data.push({
        itemName: item.name == null ? "N/A" : item.name,
        category: item.category.id == null || item.category.name == null ? "N/A" : item.category.name,
        sold: item.soldCount,
        soldPrice: Number(item.soldPrice).toFixed(2),
      });
    });
    return data;
  }

  static #removeIdColumn(list) {
    const data = [];
    list.map((item) => {
      const { id, ...rest } = item;
      data.push(rest);
    });
    return data;
  }

  static #formatCategories(data) {
    const cats = [];
    data.map((item) => {
      cats.push({ label: item.name, value: item.id });
    });
    return cats;
  }

  static async getSalesReportSummary(resId, userToken) {
    const params = { restaurantId: resId };
    return ApiService.GET_SALES_REPORT_SUMMARY(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            summary: this.#formatReportSummary(res.payload.record),
            paymentReceivedTypes: res.payload.paymentReceivedTypes,
            takeoutTypes: res.payload.takeoutTypes,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  // static async getSalesReportSummary(resId, userToken) {
  //   const params = { restaurantId: resId };
  //   return ApiService.GET_SALES_REPORT_SUMMARY(params, userToken)
  //     .then((res) => {
  //       if (res.code == 200) {
  //         return {
  //           loading: false,
  //           message: res.message,
  //           data: this.#formatReportSummary(res.payload.record),
  //         };
  //       }
  //     })
  //     .catch((err) => {
  //       return {
  //         loading: false,
  //         message: err.message || "An error has been occured.",
  //         data: null,
  //       };
  //     });
  // }

  static async getSalesReportList(params, userToken) {
    return ApiService.GET_SALES_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: res.payload.records,
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getSalesReportSummation(params, userToken) {
    return ApiService.GET_SALES_REPORT_SUMMATION(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: this.#formatReportSummary(res.payload.record),
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getItemWiseSalesReportList(params, userToken) {
    return ApiService.GET_ITEM_WISE_SALES_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: this.#formatItemWiseSales(res.payload.records),
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getRefundReportSummary(resId, userToken) {
    const params = { restaurantId: resId };
    return ApiService.GET_REFUNDCANCEL_REPORT_SUMMARY(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: this.#formatReportSummary(res.payload.record),
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getRefundCancelReportList(params, userToken) {
    return ApiService.GET_REFUNDCANCEL_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: res.payload.records,
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getCustomerReportSummary(resId, userToken) {
    const params = { restaurantId: resId };
    return ApiService.GET_CUSTOMER_REPORT_SUMMARY(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: this.#formatReportSummary(res.payload.record),
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getCustomerReportList(params, userToken) {
    return ApiService.GET_CUSTOMER_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: res.payload.records,
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getOrderReportSummary(resId, userToken) {
    const params = { restaurantId: resId };
    return ApiService.GET_ORDER_REPORT_SUMMARY(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: this.#formatReportSummary(res.payload.record),
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getOrderReportList(params, userToken) {
    return ApiService.GET_ORDER_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: res.payload.records,
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getOrderReportDetail(params, userToken) {
    return ApiService.GET_REPORT_ORDER_DETAIL(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: res.payload,
          };
        } else {
          return {
            loading: false,
            message: "An error has been occured.",
            data: null,
          };
        }
      })
      .catch((err) => { });
  }

  static async getDownloadSalesReport(params, userToken) {
    return ApiService.GET_DOWNLOAD_REPORT_SALES(params, userToken)
      .then((res) => {
        if (res.status == 200) {
          return {
            loading: false,
            data: res.data,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getDownloadItemWiseSalesReport(params, userToken) {
    return ApiService.GET_DOWNLOAD_REPORT_ITEM_WISE_SALES(params, userToken)
      .then((res) => {
        if (res.status == 200) {
          return {
            loading: false,
            data: res.data,
          };
        }
      })
      .catch((err) => {
        console.error(err.response.message);
      });
  }

  static async getDownloadRefundsAndCancellationReport(params, userToken) {
    return ApiService.GET_DOWNLOAD_REPORT_REFUND_AND_CANCELATION(params, userToken)
      .then((res) => {
        if (res.status == 200) {
          return {
            loading: false,
            data: res.data,
          };
        }
      })
      .catch((err) => {
        console.error(err.response.message);
      });
  }

  static async getDownloadCustomers(params, userToken) {
    return ApiService.GET_DOWNLOAD_CUSTOMERS(params, userToken)
      .then((res) => {
        if (res.status == 200) {
          return {
            loading: false,
            data: res.data,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async getDownloadOrdersReport(params, userToken) {
    return ApiService.GET_DOWNLOAD_ORDERS_REPORT(params, userToken)
      .then((res) => {
        if (res.status == 200) {
          return {
            loading: false,
            data: res.data,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static #formatFileName(fname) {
    const date = new Date(Date.now());
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");

    const name = fname.split(".")[0];
    const ext = fname.split(".")[1];
    return `${name}-${year}-${month}-${day}.${ext}`;
  }

  static downloadPDF(blob, filename) {
    try {
      const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = this.#formatFileName(filename);
      document.body.appendChild(a);
      a.click();

      // Cleanup
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  }

  static async getReportCategories(params, userToken) {
    return ApiService.GET_CATEGORY(params, userToken).then((res) => {
      if (res.code == 200) {
        const formatedCateogires = this.#formatCategories(res.payload.records);
        return formatedCateogires;
      }
    });
  }

  static getPosBankLabel(paymentReceivedTypes, posBankId, receivedType = "") {
    const bank = paymentReceivedTypes
      .filter((item) => item.value.paymentReceiveType === "CARD")
      .find((item) => item.value.posBankId === posBankId);
    return bank ? bank.label : receivedType;
  }

  static getTakeoutTypeLabel(takeoutTypes, valueObject) {
    const item = takeoutTypes.find(
      (t) => t.value.orderType === valueObject.orderType && t.value.takeoutType === valueObject.takeoutType,
    );

    return item ? item.label : "";
  }

  static getLast11(value) {
    if (!value) return "";

    return value.slice(-11);
  }

  static getFormatedPaymentsData(order) {
    const paymentMediums = order.payments?.paymentMediums || [];

    if (paymentMediums.length === 0) {
      return order.payments;
    }

    return {
      ...order.payments,
      paymentMediums: paymentMediums.map((item) => {
        const tmp = { ...item, method: `${item.method.toLowerCase()}` };

        if (item.method === "CASH") {
          tmp.amount = roundNumber(getParsedNumber(tmp.amount) + getParsedNumber(order.payments.returnAmount));
          tmp.amount = tmp.amount.toFixed(2);
          return tmp;
        }

        if (item.posBank) {
          tmp.method = `${tmp.posBank}`;
        }

        if (item.refNo) {
          tmp.method = `${tmp.method} (Ref: ${this.getLast11(item.refNo)})`;
        }


        return tmp;
      }),
    };
  }

  static async getCouponReportList(params, userToken) {
    return ApiService.GET_COUPON_REPORT_LIST(params, userToken)
      .then((res) => {
        if (res.code == 200) {
          return {
            loading: false,
            message: res.message,
            data: res.payload.records,
            page: res.payload.page,
            perPage: res.payload.perPage,
            total: res.payload.total,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }

  static async formatCouponList(data = []) {
    const formattedData = [];
    if (data.length === 0) return;

    data.forEach((el, idx) => {
      formattedData.push({
        id: el.id,
        title: el.title,
        couponCode: el.code,
        launchDate: dayjs(el.validFrom).format("YYYY-MM-DD"),
        expiryDate: dayjs(el.validUntil).format("YYYY-MM-DD"),
        noOfTimesUsed: el.usedCount,
        subTotalTotal: el.subTotal,
        couponDiscount: el.couponDiscount,
        paymentReceived: el.paymentReceived,
        valueShare: el.valueShare
      })
    });

    return formattedData;
  }


  static async getDownloadCouponsReport(params, userToken) {
    return ApiService.GET_DOWNLOAD_REPORT_COUPONS(params, userToken)
      .then((res) => {
        if (res.status == 200) {
          return {
            loading: false,
            data: res.data,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
  }


}